import React from 'react';
import './SponsorsCarousel.css';

const SPONSOR_LOGOS = [
  {
    name: 'Superteam',
    src: 'https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsuperteam-logo-text.png?alt=media&token=28b4e112-48b9-4042-86bb-5a389a75b08a',
  },
  {
    name: 'Solana',
    src: 'https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsolana-logo-text.png?alt=media&token=6b2d46d3-d53d-4064-80f1-9c3d653e88d9',
  },
  {
    name: 'Sp3nd',
    src: 'https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsp3nd-logo-text.png?alt=media&token=4e9948b8-bbee-4416-a0f7-d098c6a7051d',
  },
  {
    name: 'Phantom',
    src: 'https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fphantom-logo-text.png?alt=media&token=b2ca6899-3e9f-4297-9f57-21744d71f399',
  },
  {
    name: 'Solflare',
    src: 'https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsolflare-logo-text.png?alt=media&token=4991aa48-d111-4fc6-99a7-d493a73e098a',
  },
  {
    name: 'SNS',
    src: 'https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fsns-logo-text.png?alt=media&token=08ba75b6-5b0f-405a-ac48-85c94d0ecc04',
  },
  {
    name: 'Alchemy',
    src: 'https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Falchemy-logo-text.png?alt=media&token=500102fe-9e4d-4cb7-b697-429c6c3a8db8',
  },
];

function SponsorsCarousel() {
  // Triplicate the logos so the marquee can loop seamlessly without visible jumps
  const marqueeLogos = [...SPONSOR_LOGOS, ...SPONSOR_LOGOS, ...SPONSOR_LOGOS];

  return (
    <section className="sponsors-section" aria-label="WeSplit collaborators and ecosystem partners">
      <div className="sponsors-wrapper">
        <div className="sponsors-marquee">
          <div className="sponsors-track">
            {marqueeLogos.map((logo, index) => (
              <div className="sponsor-logo-wrapper" key={`${logo.name}-${index}`}>
                <img src={logo.src} alt={`${logo.name} logo`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SponsorsCarousel;


